import React, { useEffect, useContext } from "react";
import { AppContext } from "../../context/Context";
import { useTranslation } from "react-i18next";
import "../../assets/css/buttons.css";
import CloudOffIcon from "@mui/icons-material/CloudOff";

function ModalDisconnect() {
  const { t } = useTranslation();

  const { updateFocusOnMainScreen } = useContext(AppContext);

  //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    updateFocusOnMainScreen(false);

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          <div
            className="react-confirm-alert-body modal-status"
            style={{ width: "760px" }}
          >
            <div className="modal-status-emblem tone-alert is-retrying">
              <CloudOffIcon />
            </div>
            <h1>{t("socketStatus.disconnectTitle")}</h1>
            <p>{t("socketStatus.disconnectText")}</p>
            {/* Replaces an empty button-group div that only reserved space */}
            <div className="modal-retry-dots">
              <span />
              <span />
              <span />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalDisconnect;
